"use client";

import { c as _c } from "react/compiler-runtime";
import { useAuth } from "@clerk/nextjs";
import { useEffect } from "react";
import { installClerkBootstrapTokenGetter, setApiTokenGetter } from "@/lib/api/authToken";
import { installApiAuthFetch } from "@/lib/api/installApiAuthFetch";

/**
 * Hands Clerk's `getToken` to the API client (TX-4856).
 *
 * Mounted once, near the root, inside `ClerkProvider`. `apiRequest` then
 * attaches `Authorization: Bearer …` to every `/api/v1/*` call without any
 * caller knowing Clerk exists — which is what lets the API move to its own
 * origin later, since a cookie cannot cross one.
 *
 * Registered in an effect rather than during render because registration is a
 * side effect on a module singleton, and React may render a component more than
 * once before committing it.
 */
/*
 * Installed at MODULE LOAD, not in an effect.
 *
 * An effect runs after the first commit, and the opening burst of TanStack
 * queries fires from effects too — measured, that burst was 14 requests per
 * page going out before the interceptor existed. Module scope runs during
 * hydration, before any of them.
 *
 * `getApiToken` still falls back to Clerk's browser global, so a request that
 * somehow beats even this gets a token rather than nothing.
 */
installApiAuthFetch();
installClerkBootstrapTokenGetter();
export function ApiTokenProvider() {
  const $ = _c(4);
  const {
    getToken,
    isLoaded
  } = useAuth();
  let t0;
  let t1;
  if ($[0] !== getToken || $[1] !== isLoaded) {
    t0 = () => {
      if (!isLoaded) {
        return;
      }
      setApiTokenGetter(options => getToken({
        skipCache: options?.skipCache
      }));
      return _temp;
    };
    t1 = [getToken, isLoaded];
    $[0] = getToken;
    $[1] = isLoaded;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
  return null;
}
function _temp() {
  setApiTokenGetter(null);
  installClerkBootstrapTokenGetter();
}